module.exports = __webpack_public_path__ + "img/70_30.7545edcd.png";